import _ from "lodash";
import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { ProgressBar } from "react-bootstrap";
import SliderCourseListing from "./SliderCourseListing";
import { useDispatch, useSelector } from "react-redux";
import {
  getCheckListInsert,
  getLearningPathBroker,
  getUnAssginedOBLP,
} from "../../redux/courses/actions";
import { SessionKeys, convertTimeFormat } from "../../utils/AppUtils";
import ShimmerCardBody from "../Layouts/ShimmerCardBody";
import { setCurrentView } from "../../redux/assignCourse/actions";
import AssignCourseModal from "../modal/AssignCourseModal";
import OnBoardingSingleCard from "./OnBoardingSingleCard";
import { scroller } from "react-scroll";
import { useNavigate } from "react-router-dom";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { useTranslation } from "react-i18next";

const OnBoardingPageSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const onboardId = params.get("id");
  const isExploreTab = params.get("isExplore");

  const userRole = useSelector((state) => state.user.role);
  const [show, setShow] = useState(false);

  const authBroker = useSelector((state) => state.auth.authBroker);
  const learningPathBroker = useSelector(
    (state) => state.courses.learningPathBroker
  );
  const unassignedOBLP = useSelector((state) => state.courses.unassignedOBLP);
  const [activeTab, setActiveTab] = useState("assigned");
  const [assignedList, setAssignedList] = useState([]);
  const [assignedLoader, setAssignedLoader] = useState(false);
  const [unassignedList, setUnAssignedList] = useState([]);
  const [unassignedLoader, setUnAssignedLoader] = useState(false);

  useEffect(() => {
    if (isExploreTab === "true") {
      setActiveTab("more");
    }
  }, []);

  useEffect(() => {
    if (assignedList?.length > 0 || unassignedList?.length > 0) {
      scroller.scrollTo(onboardId, {
        duration: 50,
        delay: 5,
        smooth: "easeInOutQuart",
      });
    }
  }, [assignedList, unassignedList]);

  useEffect(() => {
    if (!_.isEmpty(authBroker) && activeTab === "more") {
      dispatch(
        getUnAssginedOBLP({
          module: "getAllLearningPathBroker",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            broker_id: authBroker?.payload?.user?.broker_id,
            is_onboarding: true,
            assigned: 0,
          },
        })
      );
    }
  }, [dispatch, authBroker, activeTab]);

  useEffect(() => {
    if (!_.isEmpty(authBroker) && activeTab === "assigned") {
      dispatch(
        getLearningPathBroker({
          module: "getAllLearningPathBroker",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            broker_id: authBroker?.payload?.user?.broker_id,
            is_onboarding: true,
            assigned: 1,
          },
        })
      );
    }
  }, [dispatch, authBroker, activeTab]);

  useEffect(() => {
    // console.log('Action Path broker', learningPathBroker)
    if (
      !_.isEmpty(learningPathBroker) &&
      learningPathBroker.status === "success" &&
      _.isArray(learningPathBroker.payload.payload)
    ) {
      const learningData = _.cloneDeep(learningPathBroker.payload.payload);
      if (!_.isEmpty(learningData)) {
        const newLearningList = setOBLPData(learningData);
        setAssignedList(newLearningList);
        setAssignedLoader(false);
      } else {
        setAssignedLoader(false);
      }
      // setOnBoardingData(learningPathBroker.payload)
      //   if (learningPathBroker.payload.payload.length === 0) {
      //     setNoData(true)
      //   }
      //   dispatch(getLearningPathBrokerClear());
    }
  }, [learningPathBroker]);

  useEffect(() => {
    // console.log('Action Path broker', learningPathBroker)
    if (
      !_.isEmpty(unassignedOBLP) &&
      unassignedOBLP.status === "success" &&
      _.isArray(unassignedOBLP.payload.payload)
    ) {
      const learningData = _.cloneDeep(unassignedOBLP.payload.payload);
      if (!_.isEmpty(learningData)) {
        const newLearningList = setOBLPData(learningData);
        setUnAssignedList(newLearningList);
        setUnAssignedLoader(false);
      } else {
        setUnAssignedLoader(false);
      }
      // setOnBoardingData(unassignedOBLP.payload)
      //   if (unassignedOBLP.payload.payload.length === 0) {
      //     setNoData(true)
      //   }
      //   dispatch(getLearningPathBrokerClear());
    }
  }, [unassignedOBLP]);

  const setOBLPData = (learningData) => {
    // console.log('learningPath', learningData)
    let newLearningList = [];
    for (let learning of learningData) {
      let sendFlag = false;
      console.log("Learning", sendFlag, learning);
      if (learning.is_onboarding) {
        // console.log('setLearningPathData', learning)
        let courseCount = learning.courseList.length;
        let completedCourseCount = 0;
        for (let [index, course] of learning.courseList.entries()) {
          learning.is_manager_checklist = false;
          let currentCourse = course;
          let nextCourse = learning.courseList[index + 1];
          if (learning.sequence === 1) {
            if (index === 0) {
              currentCourse.isLock = false;
            }
            currentCourse.isLock =
              currentCourse.isLock === false ? currentCourse.isLock : true;
            if (currentCourse.crs_progress > 0) {
              // currentCourse.isLock = false;
              if (index !== learning.courseList.length - 1) {
                nextCourse.isLock =
                  _.toNumber(currentCourse.crs_progress) >= 100 &&
                  !currentCourse.isLock
                    ? false
                    : true;
              }
            }
          } else {
            currentCourse.isLock = currentCourse.isLock
              ? currentCourse.isLock
              : false;
          }
          currentCourse.duration =
            currentCourse?.entity_type === "video"
              ? convertTimeFormat(_.toNumber(currentCourse.duration), true, t)
              : convertTimeFormat(_.toNumber(currentCourse.duration), false, t);
          currentCourse.durationUnit = "";
          // console.log("detaiiii", course)
          if (index < learning.courseList.length - 1) {
            if (
              !currentCourse?.is_checklist_approved &&
              currentCourse?.is_checklist_present
            ) {
              nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false;
            } else if (
              currentCourse?.is_checklist_approved &&
              currentCourse?.is_checklist_present
            ) {
              nextCourse.isLock = false;
            }

            if (currentCourse.is_checklist_present) {
              learning.is_manager_checklist = true;
              nextCourse.is_manager_checklist = true;
              console.log("HI", currentCourse.is_checklist_present, nextCourse);
            }
          }
          if (
            !currentCourse?.is_checklist_approved &&
            currentCourse?.is_checklist_present &&
            !sendFlag
          ) {
            if (
              currentCourse.crs_progress >= 100 &&
              !currentCourse.isLock &&
              index !== learning.courseList.length - 1
            ) {
              console.log(
                getCheckListInsert({
                  module: "checklist-insert",
                  postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    lp_id: learning?.id,
                    entity_id:
                      currentCourse.source === "broker"
                        ? currentCourse.id
                        : currentCourse?.crscd,
                    entity_type: !currentCourse?.is_level ? "course" : "level",
                  },
                })
              );
              dispatch(
                getCheckListInsert({
                  module: "checklist-insert",
                  postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    lp_id: learning?.programID,
                    entity_id:
                      currentCourse.source === "broker"
                        ? currentCourse.id
                        : currentCourse?.crscd,
                    entity_type: !currentCourse?.is_level ? "course" : "level",
                  },
                })
              );
              sendFlag = true;
            }
          }
          // if (course.durationUnit === "Hours") {
          //   const convertArray = _.toString(course.duration).includes(":")
          //     ? course.duration.split(":")
          //     : [course.duration, 0];
          //   const hoursMinutes = _.toNumber(convertArray[0]) * 60;
          //   const minutes = _.toNumber(convertArray[1]);
          //   const totalMinutes = hoursMinutes + minutes;
          //   course.duration = totalMinutes;
          // }
          // if (_.toNumber(course.duration) > 60) {
          //   let hours = Math.floor(course.duration / 60);
          //   let minutes = course.duration % 60;
          //   hours = hours >= 10 ? hours : `0${hours}`;
          //   minutes = minutes >= 10 ? minutes : `0${minutes}`;
          //   // console.log(course.duration, hours, minutes)
          //   course.duration = `${hours} ${hours > 1 ? "Hours" : "Hour"
          //     } ${minutes} ${minutes > 1 ? "Mins" : "Min"}`;
          //   course.durationUnit = "";
          // } else if (_.toNumber(course.duration) < 60) {
          //   console.log('Minutes')
          //   course.duration = `${course.duration} ${course.duration > 1 ? "Mins" : "Min"
          //     }`;
          //   course.durationUnit = "";
          // } else {
          //   console.log('hour', course)
          //   course.duration = "1 Hour";
          //   course.durationUnit = "";
          // }
          if (course.crs_progress === 100) {
            completedCourseCount++;
          }
        }
        // for (let course of learning.courseList) {
        //   course.is_manager_checklist = learning.is_manager_checklist
        // }
        // learning.programprogress = completedCourseCount / courseCount * 100;
        newLearningList.push(learning);
      }
    }
    return newLearningList;
  };

  const showProgessNaming = (progress) => {
    if (_.toNumber(progress) === 0) {
      return "Not Started";
    } else if (_.toNumber(progress) === 100) {
      return "Completed";
    } else {
      return "In Progress";
    }
  };

  const renderLoader = () => {
    return (
      <>
        <div className="mt-5 mb-5">
          <div className="row">
            {[1, 2, 3, 4].map((i) => {
              return <ShimmerCardBody key={`shimmer-${i}`} />;
            })}
          </div>
        </div>
      </>
    );
  };

  const renderAssignedEmptyCard = () => {
    return (
      <>
        <div className="mt-5 h-60">
          <div className="not-found">
            <div className="interboxes">
            <NotFoundImage width={200} height={219} />
              <p>
                Onboarding Action Paths that are assigned to you, will appear
                here. <br />
                Click{" "}
                <a
                  className="hyperlink-to"
                  onClick={() => {
                    setActiveTab("more");
                  }}
                >
                  here
                </a>{" "}
                to explore an Onboarding Action Paths.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderUnAssignedEmptyCard = () => {
    return (
      <>
        <div className="mt-5 h-60">
          <div className="not-found">
            <div className="interboxes">
            <NotFoundImage width={200} height={219} />
              <p>
                Please contact your Manager to assign an onboarding learning
                path.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderData = (listArray, isAssigned = true) => {
    return (
      <>
        {!_.isEmpty(listArray)
          ? listArray.map((data, index) => {
              return (
                <>
                  <OnBoardingSingleCard index={index} data={data} />
                </>
              );
            })
          : isAssigned
          ? renderAssignedEmptyCard()
          : renderUnAssignedEmptyCard()}
      </>
    );
  };

  return (
    <>
      <div className="mt-5">
        <div className="rows my_learningpath_tab onboarding">
          <Tabs
            onSelect={(k) => setActiveTab(k)}
            activeKey={activeTab}
            defaultActiveKey="assigned"
            className=""
          >
            <Tab eventKey="assigned" title="Assigned">
              {assignedLoader ? renderLoader() : renderData(assignedList, true)}
              {}
            </Tab>
            <Tab eventKey="more" title="Explore More">
              {unassignedLoader
                ? renderLoader()
                : renderData(unassignedList, false)}
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default OnBoardingPageSection;
